import classnames from 'classnames';
import isFunction from 'lodash/isFunction';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';
import React from 'react';
import { SegmentEventTypes } from '../../data/tracking';
import Analytics from '../../utils/Analytics';
import { WrappedButtonType } from './WrappedButtonType.enum';

export const WrappedSocialButton = props => {
	// props for this component
	const {
		className = '',
		dataqa = 'ui-social-button-common',
		buttonType = '',
		arialLabel = '',
		onClick,
		...rest // rest of props for PrimeReact Button
	} = props;

	const clickHandler = e => {
		Analytics.trackSegmentEvent({
			trackingData: {
				field_type: 'socialbutton',
				field_name_dataqa: `${dataqa}-social-button`,
			},
			eventType: SegmentEventTypes.UserInteraction,
		});

		if (isFunction(onClick)) {
			onClick(e);
		}
	};

	// assigning style classname
	const buttonCls = classnames({
		'ui-button-facebook': buttonType === WrappedButtonType.Facebook,
		'ui-button-twitter': buttonType === WrappedButtonType.Twitter,
	});

	return (
		<div
			className={`common-ui-button social-button ${className}`}
			data-qa={dataqa}
		>
			<Button
				className={buttonCls}
				dataqa={dataqa}
				onClick={clickHandler}
				{...rest}
			>
				<span aria-label={arialLabel} />
			</Button>
		</div>
	);
};

WrappedSocialButton.propTypes = {
	// Name of the icon.
	icon: PropTypes.string,

	// Position of the icon - "left" or "right".
	iconPos: PropTypes.string,

	// Content of the tooltip.
	tooltip: PropTypes.any,

	// Configuration of the tooltip, refer to the tooltip documentation for more information.
	tooltipOptions: PropTypes.object,

	// Click handler.
	onClick: PropTypes.func,

	/* Above props are specified by the documentation */

	// Additional ClassName of the component.
	className: PropTypes.string,

	// WrappedButtonType enum. Default to Primary.
	buttonType: PropTypes.oneOf([
		WrappedButtonType.Facebook,
		WrappedButtonType.Twitter,
	]),

	// For QA automation testing.
	dataqa: PropTypes.string,
};
